export interface INotification {
    message: string;
    type: NotificationType;
    id: number;
}

export enum NotificationType {
    error = "error",
    success = "success"
}